import { render, staticRenderFns } from "./CompanyDesktopMultiEmployeeMealSummary.vue?vue&type=template&id=9d2049c6"
import script from "./CompanyDesktopMultiEmployeeMealSummary.vue?vue&type=script&lang=js"
export * from "./CompanyDesktopMultiEmployeeMealSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports